import { ThemeOptions } from '@mui/material/styles';
import darkThemeOptions from './darkThemeOptions';

import ulterLogo from '../assets/ulteer_v5_logo_2025.png';
import tixntrxLogo from '../assets/tixntrxLogo.png';

export interface DomainConfig {
  themeOptions: ThemeOptions;
  logo: string;
  brandName: string;
}

// Deep clone base theme to avoid mutating the original darkThemeOptions
const createDomainTheme = (primaryColor: string, backgroundDefault: string, backgroundPaper: string): ThemeOptions => {
  return {
    ...darkThemeOptions,
    palette: {
      ...darkThemeOptions.palette,
      primary: {
        ...darkThemeOptions.palette?.primary,
        main: primaryColor,
        contrastText: primaryColor, // Override the hardcoded 'red'
      },
      background: {
        ...darkThemeOptions.palette?.background,
        default: backgroundDefault,
        paper: backgroundPaper,
      },
      info: {
        ...darkThemeOptions.palette?.info,
        500: primaryColor, // Override the hardcoded '#F0635A' (red)
      }
    },
  };
};

// TIXNTRX is the default (host app)
const tixntrxThemeOptions = createDomainTheme(
  '#0BF864', // Tixntrx Neon Green
  '#121212',
  '#191919'
);

// ULTER is the specific exception
const ulterThemeOptions = createDomainTheme(
  '#F2583E', // Ulter Orange
  '#000000',
  '#191919'
);

const tixntrxMapping: DomainConfig = {
  themeOptions: tixntrxThemeOptions,
  logo: tixntrxLogo,
  brandName: 'TIXNTRX',
};

const ulterMapping: DomainConfig = {
  themeOptions: ulterThemeOptions,
  logo: ulterLogo,
  brandName: 'ULTER',
};

const domainConfigs: Record<string, DomainConfig> = {
  'ulterbooking.com': ulterMapping,
  'www.ulterbooking.com': ulterMapping,
  'localhost': tixntrxMapping, // explicit mapping for local dev, although fallback is tixntrx
};

export const getDomainConfig = (hostname: string): DomainConfig => {
  // We strictly match the domain, if not found, it falls back to the host app (tixntrx)
  return domainConfigs[hostname] || tixntrxMapping;
};
